"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = __importDefault(require("react"));
var DrawerBody = react_2.default.forwardRef(function (_a, ref) {
    var children = _a.children;
    return (react_1.jsx("div", { ref: ref, css: { flex: 1, overflow: 'overlay' } },
        react_1.jsx("div", { css: {
                padding: '16px 24px',
            } }, children)));
});
exports.default = DrawerBody;
